import React, { useCallback, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

export const SEARCH_INPUT_ID = "dnh-search-query";

export const focusDnhSearchInput = () => {
  const input = document.getElementById(SEARCH_INPUT_ID);
  if (!input) return;
  input.focus({ preventScroll: true });
  const bounds = input.getBoundingClientRect();
  const headerBottom = document.querySelector("header")?.getBoundingClientRect().bottom || 0;
  if (bounds.top < headerBottom || bounds.bottom > window.innerHeight) {
    input.scrollIntoView({ block: "center", behavior: "instant" });
  }
};

const useOpenDnhSearch = () => {
  const location = useLocation();
  const navigate = useNavigate();
  return useCallback(() => {
    if (location.pathname.replace(/\/+$/, "") === "/search") {
      // Wait for a mobile drawer to close before measuring/focusing the field.
      requestAnimationFrame(focusDnhSearchInput);
    } else {
      navigate("/search");
    }
  }, [location.pathname, navigate]);
};

export const DnhSearchLink = ({ children, onClick, ...props }) => {
  const openSearch = useOpenDnhSearch();
  return <Link {...props} to="/search" onClick={event => {
    onClick?.(event);
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    openSearch();
  }}>{children}</Link>;
};

// The keyboard shortcut is another entry to DNH Search, not a second search UI.
export const SearchShortcut = () => {
  const openSearch = useOpenDnhSearch();
  useEffect(() => {
    const onKey = event => {
      if ((event.metaKey || event.ctrlKey) && !event.altKey && event.key.toLowerCase() === "k" && !event.isComposing) {
        event.preventDefault();
        if (!event.repeat) openSearch();
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [openSearch]);
  return null;
};